"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwFlexbox = _interopRequireDefault(require("./CwFlexbox.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Enums = require("../../utils/Enums");

var CwFlexbox = function CwFlexbox(props) {
  var _cx;

  return _react.default.createElement("div", {
    "data-cwid": props.cwId,
    onClick: props.onClick,
    style: props.style,
    className: (0, _classnames.default)(_CwFlexbox.default.wrap, props.className, (_cx = {}, (0, _defineProperty2.default)(_cx, _CwFlexbox.default.column, props.column), (0, _defineProperty2.default)(_cx, _CwFlexbox.default.verticalAlign, props.verticalAlign), (0, _defineProperty2.default)(_cx, _CwFlexbox.default.horizontalAlign, props.horizontalAlign), (0, _defineProperty2.default)(_cx, _CwFlexbox.default.leftAlign, props.align === _Enums.AlignmentEnum.LEFT), (0, _defineProperty2.default)(_cx, _CwFlexbox.default.centerAlign, props.align === _Enums.AlignmentEnum.CENTER), (0, _defineProperty2.default)(_cx, _CwFlexbox.default.rightAlign, props.align === _Enums.AlignmentEnum.RIGHT), _cx))
  }, props.children);
};

CwFlexbox.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,
  column: _propTypes.default.bool,
  verticalAlign: _propTypes.default.bool,
  horizontalAlign: _propTypes.default.bool,
  align: _propTypes.default.oneOf([_Enums.AlignmentEnum.LEFT, _Enums.AlignmentEnum.CENTER, _Enums.AlignmentEnum.RIGHT]),
  style: _propTypes.default.object,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func
};
var _default = CwFlexbox;
exports.default = _default;